import React from 'react'
import styled from 'styled-components'
import * as FilterAccordion from 'components/molecules/Filter/partials/FilterAccordion/FilterAccordion.styles'

let contextOfUse = ''

export const SelectContainer = styled(
  React.forwardRef((props, ref) => {
    // extract minWidth to avoid setting as data-property
    // eslint-disable-next-line no-unused-vars
    const { minWidth, ...rest } = props

    contextOfUse = props.context
    return <div ref={ ref } { ...rest } />
  })
)`
  position: relative;
  min-width: ${ (props) => props.minWidth || 205 }px;

  ${ FilterAccordion.ChildrenWrapper } & {
    border: 1px solid ${ (props) => props.theme.colors['icon-grau3'] };
    margin-bottom: 20px;

    :last-child {
      margin-bottom: 0;
    }
  }
`

export const Select = styled.span`
  display: block;
  margin: 0;
`

export const Selection = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${ (props) => (props.disabled ? 'inherit' : 'pointer') };
  user-select: none;
  height: 48px;
  padding: 9px 12px;
  min-width: ${ () => (contextOfUse === 'resultSort' ? '210px' : '0') };
  border: 0;
  background: ${ (props) =>
    contextOfUse === 'resultSort'
      ? props.theme.colors.sortSelectTitle
      : props.backgroundColor };

  &[aria-expanded='true']:after {
    transform: rotate(180deg);
  }

  :hover,
  :focus {
    outline: 0;

    ::after {
      transform: ${ (props) => (props.disabled ? 'none' : 'rotate(90deg)') };
    }
  }

  ${ (props) => {
    if (!props.disabled) {
      return `
                  ::after {
                    display: inline-block;
                    font: normal normal normal 14.54545px "aok-icons-functional";
                    line-height: 1;
                    text-rendering: auto;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    transform: translate(0, 0);
                    content: "";
                    ${ (props) =>
                      !props.disabled
                        ? `${ FilterAccordion.Container } & {
                        content: "";
                    }`
                        : `` }
                    vertical-align: middle;

                    transition: .3s transform ease-out;
                    transform: rotate(0deg);
                    transform-origin: center center;

                    margin-top: -.5em;
                    position: absolute;
                    top: 50%;
                    right: 12px;
                    color: ${ (props) =>
                      contextOfUse === 'resultSort'
                        ? props.theme.colors['standard-schwarz']
                        : '#838383' };
                    pointer-events: none;

                    font-size: 16px;
                }
            `
    }
  } }
`

export const SelectionTitle = styled.div`
  padding-right: 20px;
  line-height: 28px;
  white-space: nowrap;
  display: flex;
  align-items: center;

  ${ FilterAccordion.Container } & {
    color: ${ (props) => props.theme.colors.grau2 };
  }

  > span {
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  .active-value-with-tooltip {
    display: flex;
    align-items: center;

    > span:first-child {
      width: 100%;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }

    > span:last-child {
      margin-left: 10px;
      margin-right: 5px;
    }
  }
`

export const SelectOptions = styled.span`
  display: ${ (props) => (props.expand ? 'block' : 'none') };
  position: absolute;
  min-width: 100%;
  top: 100%;
  left: 0;
  z-index: ${ (props) => props.theme.zIndices.dropdown };
  border: 1px solid ${ (props) => props.theme.colors['aok-gruen'] };
  background-color: #f6f6f6;

  ${ (props) => {
    if (contextOfUse === 'resultSort') {
      return `
                background-color: ${ props.theme.colors.sortSelectOptions };
                border-color: transparent;
            `
    }
  } }
`

/** @todo this could be a base component */
export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  z-index: ${ (props) => props.theme.zIndices.modal };
`

export const ListItem = styled.li`
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px 15px;
  line-height: 1.39;
  white-space: nowrap;
  cursor: pointer;
  // set max-width for list item
  text-overflow: ellipsis;
  max-width: 500px;
  overflow-x: hidden;
  display: flex;
  align-items: center;

  &:hover,
  &:focus,
  [aria-selected='true'] {
    outline: 0;
    background: ${ (props) =>
      contextOfUse === 'resultSort'
        ? props.theme.colors['icon-grau3']
        : props.theme.colors['hintergrund-prio3'] };
  }
`
